/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiHitData } from '../api-models';
// @ts-ignore
import { BaseResponseOfSaasEmployeeMetricsResponse } from '../api-models';
// @ts-ignore
import { MetricsRequest } from '../api-models';
/**
 * MetricsApi - axios parameter creator
 * @export
 */
export const MetricsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [facilityId] 
         * @param {boolean} [onlyShowNewScheduler] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsEmployeesGet: async (facilityId?: string, onlyShowNewScheduler?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Metrics/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (onlyShowNewScheduler !== undefined) {
                localVarQueryParameter['onlyShowNewScheduler'] = onlyShowNewScheduler;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MetricsRequest} [metricsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsRequestCountPost: async (metricsRequest?: MetricsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Metrics/request-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metricsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [eventName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsTrackEventGet: async (eventName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Metrics/TrackEvent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (eventName !== undefined) {
                localVarQueryParameter['eventName'] = eventName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetricsApi - functional programming interface
 * @export
 */
export const MetricsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetricsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [facilityId] 
         * @param {boolean} [onlyShowNewScheduler] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metricsEmployeesGet(facilityId?: string, onlyShowNewScheduler?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfSaasEmployeeMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metricsEmployeesGet(facilityId, onlyShowNewScheduler, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MetricsRequest} [metricsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metricsRequestCountPost(metricsRequest?: MetricsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiHitData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metricsRequestCountPost(metricsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [eventName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metricsTrackEventGet(eventName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metricsTrackEventGet(eventName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MetricsApi - factory interface
 * @export
 */
export const MetricsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetricsApiFp(configuration)
    return {
        /**
         * 
         * @param {MetricsApiMetricsEmployeesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsEmployeesGet(requestParameters: MetricsApiMetricsEmployeesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfSaasEmployeeMetricsResponse> {
            return localVarFp.metricsEmployeesGet(requestParameters.facilityId, requestParameters.onlyShowNewScheduler, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MetricsApiMetricsRequestCountPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsRequestCountPost(requestParameters: MetricsApiMetricsRequestCountPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ApiHitData>> {
            return localVarFp.metricsRequestCountPost(requestParameters.metricsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MetricsApiMetricsTrackEventGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsTrackEventGet(requestParameters: MetricsApiMetricsTrackEventGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.metricsTrackEventGet(requestParameters.eventName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for metricsEmployeesGet operation in MetricsApi.
 * @export
 * @interface MetricsApiMetricsEmployeesGetRequest
 */
export interface MetricsApiMetricsEmployeesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MetricsApiMetricsEmployeesGet
     */
    readonly facilityId?: string

    /**
     * 
     * @type {boolean}
     * @memberof MetricsApiMetricsEmployeesGet
     */
    readonly onlyShowNewScheduler?: boolean
}

/**
 * Request parameters for metricsRequestCountPost operation in MetricsApi.
 * @export
 * @interface MetricsApiMetricsRequestCountPostRequest
 */
export interface MetricsApiMetricsRequestCountPostRequest {
    /**
     * 
     * @type {MetricsRequest}
     * @memberof MetricsApiMetricsRequestCountPost
     */
    readonly metricsRequest?: MetricsRequest
}

/**
 * Request parameters for metricsTrackEventGet operation in MetricsApi.
 * @export
 * @interface MetricsApiMetricsTrackEventGetRequest
 */
export interface MetricsApiMetricsTrackEventGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MetricsApiMetricsTrackEventGet
     */
    readonly eventName?: string
}

/**
 * MetricsApi - object-oriented interface
 * @export
 * @class MetricsApi
 * @extends {BaseAPI}
 */
export class MetricsApi extends BaseAPI {
    /**
     * 
     * @param {MetricsApiMetricsEmployeesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public metricsEmployeesGet(requestParameters: MetricsApiMetricsEmployeesGetRequest = {}, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).metricsEmployeesGet(requestParameters.facilityId, requestParameters.onlyShowNewScheduler, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MetricsApiMetricsRequestCountPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public metricsRequestCountPost(requestParameters: MetricsApiMetricsRequestCountPostRequest = {}, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).metricsRequestCountPost(requestParameters.metricsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MetricsApiMetricsTrackEventGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public metricsTrackEventGet(requestParameters: MetricsApiMetricsTrackEventGetRequest = {}, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).metricsTrackEventGet(requestParameters.eventName, options).then((request) => request(this.axios, this.basePath));
    }
}
